import { FILE_INLINE_CARD_PARTS } from './fileInlineCardParts';
import type { FileInlineCardStyleConfig } from './types';

const BASE_STYLE = {
  container: {
    display: 'inline-flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: 0.25,
    padding: 0.25,
    paddingRight: 0.5,
    minWidth: 2.5,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'separator.border',
    borderRadius: 'sm',
    fontWeight: 'medium',
    color: 'interaction.main',
    backgroundColor: 'page.surface',
    transitionProperty: 'common',
    transitionDuration: '0.2s',
    _focus: {
      boxShadow: 'focus',
    },
    _hover: {
      backgroundColor: 'interaction.surfaceHover',
      borderColor: 'interaction.hover',
      color: 'interaction.hover',
      textDecoration: 'none',
    },
    _active: {
      backgroundColor: 'interaction.surfaceActive',
      borderColor: 'interaction.active',
      color: 'interaction.active',
    },
    _disabled: {
      backgroundColor: 'page.surface',
      borderColor: 'separator.border',
      color: 'feature.placeholder',
      cursor: 'not-allowed',
    },
  },
  label: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flexShrink: 1,
  },
  icon: {
    flexShrink: 0,
  },
};

const SIZES: FileInlineCardStyleConfig['sizes'] = {
  sm: {
    container: {
      height: 3,
      fontSize: 'sm',
      lineHeight: 'sm',
    },
    icon: {
      boxSize: 2,
    },
  },
  md: {
    container: {
      height: 3.5,
      fontSize: 'md',
      lineHeight: 'md',
    },
    icon: {
      boxSize: 2.5,
    },
  },
  lg: {
    container: {
      height: 4,
      fontSize: 'lg',
      lineHeight: 'lg',
    },
    icon: {
      boxSize: 3,
    },
  },
};

export const FILE_INLINE_CARD_STYLE_CONFIG: FileInlineCardStyleConfig = {
  parts: FILE_INLINE_CARD_PARTS,
  baseStyle: BASE_STYLE,
  sizes: SIZES,
  defaultProps: { size: 'sm' },
};
